import { Crown } from 'lucide-react'
import { cn } from '@/lib/utils'

type LockBadgeVariant = 'gold' | 'violet'

interface LockBadgeProps {
  variant: LockBadgeVariant
  className?: string
}

const variantStyles: Record<LockBadgeVariant, string> = {
  gold: 'text-amber-400 drop-shadow-[0_0_4px_rgba(251,191,36,0.6)]',
  violet: 'text-violet-400 drop-shadow-[0_0_4px_rgba(139,92,246,0.6)]',
}

export function LockBadge({ variant, className }: LockBadgeProps) {
  return (
    <Crown
      className={cn(
        'size-4',
        variantStyles[variant],
        className
      )}
    />
  )
}
